import { gql } from '@/modes/company/gql';

export const CREATE_BACKFLOW_TESTER = gql(`
  mutation CreateBackflowTester($input: VendorInput!) {
    createVendor(input: $input) {
      id
      accountNumber
      status
      profile {
        id
        type
        name
        firstName
        lastName
        phones {
          id
          subType
          value
          extension
        }
        emails {
          id
          subType
          value
        }
        contactAddressId
        contactAddress {
          id
          street1
          street2
          city
          state
          zip
          zipExt
        }
        billingAddressId
        billingAddress {
          id
          street1
          street2
          city
          state
          zip
          zipExt
        }
      }
      user {
        email
      }
      notes
    }
  }
`);

export const UPDATE_BACKFLOW_TESTER = gql(`
  mutation UpdateBackflowTester($vendorId: ID!, $input: VendorInput!) {
    updateVendor(vendorId: $vendorId, input: $input) {
      id
      accountNumber
      status
      profile {
        id
        type
        name
        firstName
        lastName
        phones {
          id
          subType
          value
          extension
        }
        emails {
          id
          subType
          value
        }
        contactAddressId
        contactAddress {
          id
          street1
          street2
          city
          state
          zip
          zipExt
        }
        billingAddressId
        billingAddress {
          id
          street1
          street2
          city
          state
          zip
          zipExt
        }
      }
      notes
    }
  }
`);
